import {createClient} from 'contentful';

export default createClient({
    space: "4dhzd9gyx0x4",
    accessToken: "N_MnpruL2752BtwKyxBAV3sJ5rxe-5GJfveRXwJ54D8"
});